document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.quote-slider swiper-container')
    .forEach((swiperEl) => {
      if (!!swiperEl.initialized) return;

      const swiperParams = {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 10,
        loop: true,
        centerInsufficientSlides: true,
        breakpoints: {
          [Theme.breakpoints.lg]: {
            slidesPerView: 2,
          },
          [Theme.breakpoints.xl]: {
            slidesPerView: 3,
          },
        },
        navigation: {
          clickable: true,
          nextEl: swiperEl
            .closest(".quote-slider")
            ?.querySelector(".quote-slider__next"),
          prevEl: swiperEl
            .closest(".quote-slider")
            ?.querySelector(".quote-slider__prev"),
        },
      };

      // now we need to assign all parameters to Swiper element
      Object.assign(swiperEl, swiperParams);

      // and now initialize it
      swiperEl.initialize();
    });
});
